import pluralize from "pluralize"

export type DurationFormat = "short" | "long"

/**
 * Format a duration in seconds as hours and minutes, dropping whole-zero parts.
 *
 * "short" abbreviates the units ("1h 30m", "2h", "45m").
 * "long" spells them out ("1 hour 30 minutes", "2 hours", "45 minutes").
 */
export default function formatDuration(seconds: number, format: DurationFormat = "short"): string {
    const hours = Math.trunc(seconds / 3600)
    const minutes = Math.trunc((seconds % 3600) / 60)

    const parts: string[] = []
    if (hours) {
        parts.push(format === "long" ? pluralize("hour", hours, true) : `${hours}h`)
    }
    if (minutes || !hours) {
        parts.push(format === "long" ? pluralize("minute", minutes, true) : `${minutes}m`)
    }
    return parts.join(" ")
}
